import React, { useEffect, useRef, useState } from 'react';
import { apiFetch } from '../api';


export default function ProjectActivityBar({ onNavigate }) {
  const [activity, setActivity] = useState({ status: 'idle' });
  const timerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      try {
        const response = await apiFetch('/project/activity');
        const data = await response.json();
        if (!cancelled && response.ok) setActivity(data);
        const active = ['starting', 'running'].includes(data.status);
        timerRef.current = window.setTimeout(poll, active ? 2000 : 8000);
      } catch (_) {
        if (!cancelled) timerRef.current = window.setTimeout(poll, 8000);
      }
    };
    poll();
    return () => {
      cancelled = true;
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  if (activity.status === 'idle') return null;
  if (activity.status === 'interrupted') {
    return (
      <div className="border-b border-amber-200 bg-amber-50 px-6 py-3 text-sm text-amber-900" role="status">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4">
          <span><strong>{activity.label} was interrupted.</strong> {activity.message}</span>
          {activity.kind && <button className="shrink-0 font-semibold underline" onClick={() => onNavigate(activity.kind)}>Review</button>}
        </div>
      </div>
    );
  }

  const percent = activity.progress == null ? 8 : Math.max(2, Math.min(100, Math.round(activity.progress * 100)));
  return (
    <button className="block w-full border-b border-[#74d6d1]/30 bg-[#071a26] px-6 py-3 text-left text-white" onClick={() => activity.kind && onNavigate(activity.kind)}>
      <div className="mx-auto flex max-w-7xl items-center gap-4">
        <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-white/20">
          <div className="h-full rounded-full bg-[#74d6d1] transition-[width] duration-200" style={{ width: `${percent}%` }} />
        </div>
        <div className="min-w-0 text-sm text-white/90">
          {activity.message || activity.label}
          {activity.total ? ` · ${(activity.processed || 0).toLocaleString()} of ${activity.total.toLocaleString()}` : ''}
        </div>
      </div>
    </button>
  );
}
